export default __webpack_public_path__ + "static/media/consulting1.ca912ed8.jpg";